import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 70px;
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  margin-top: 3px;

  .wrapper {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 1.4rem;
    overflow-x: scroll;

    @media (min-width: 578px) {
      overflow-x: auto;
    }
  }
`;

export const NavButton = styled.button<{ active: boolean }>`
  font-family: ${({ theme }) => theme.font.extra_condensed};
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.texts_light};
  display: block;
  height: 70px;
  border-bottom: 5px solid ${({ theme }) => theme.colors.white};
  padding: 0;
  white-space: nowrap;

  ${({ active }) =>
    active &&
    css`
      color: ${({ theme }) => theme.colors.blue03.color};
      border-color: ${({ theme }) => theme.colors.blue03.color};
    `}
`;
